import { Upload, message } from "antd";
import type { UploadProps } from "antd";
import type { UploadListType } from "antd/es/upload/interface";

import { renderAntDMessageConfig } from "../../../utils/renderAntDMessageConfig";
import { localUploadBaseProps } from "../../../utils/localUploadRequest";

const typeMap = {
  mp3: ["audio/mp3", "audio/mpeg"],
  mp4: ["video/mp4"],
  png: ["image/png"],
  jpg: ["image/jpeg", "image/jpg"],
};

type UploadType = keyof typeof typeMap;

const validateFileType = (file: File, validTypes: string[], type: string) => {
  const isValid = validTypes.includes(file.type);
  if (!isValid) message.error(renderAntDMessageConfig(`${file.name} is not a valid ${type} file`));
  return isValid || Upload.LIST_IGNORE;
};

export function createUploadProps(
  type: UploadType,
  name: string,
  maxCount = 1,
  listType: UploadListType = 'text',
): UploadProps {
  return {
    ...localUploadBaseProps,
    name,
    maxCount,
    beforeUpload: async (file) => {
      return validateFileType(file, typeMap[type], type.toUpperCase());
    },
    onChange: (info) => {
      if (info.file.status === "done") {
        message.success(
          renderAntDMessageConfig(
            `${info.file.name} file uploaded successfully`
          )
        );
      } else if (info.file.status === "error") {
        message.error(
          renderAntDMessageConfig(`${info.file.name} file upload failed.`)
        );
      }
    },
    listType: listType,
  };
}
